module.exports = __webpack_public_path__ + "img/IMG_1699_Black_MockedUp.d79a8dc5.jpg";